import type { SalesforcePaymentsConfig } from '../../types/config';
import type { PaymentIntentRequest } from '../../types/paymentRequest';
import { ComponentType, type PaymentMethodSet } from '../../types/paymentMethodSet';
import { Component } from '../component';
import type SfpContext from '../../sfp-context';
import type { MetadataReader } from '../../util/metadata-reader';

export class Messages extends Component {
  TYPE = ComponentType.MESSAGES;

  constructor(
    context: SfpContext,
    metadataReader: MetadataReader,
    paymentMethodSet: PaymentMethodSet,
    config: SalesforcePaymentsConfig,
    paymentRequest: PaymentIntentRequest,
    elementOrSelectorToMountTo: string | HTMLElement
  ) {
    super(context, null, metadataReader, paymentMethodSet, null, paymentRequest, elementOrSelectorToMountTo);
    // TODO implement
  }
}
